import { Text } from '@components/primitives';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { Linking, Pressable } from 'react-native';
import styles from './style';

type VoucherCodeProps = {
  redeemUrl?: string;
};

function VoucherCode({ redeemUrl = '' }: VoucherCodeProps): React.JSX.Element | null {
  if (redeemUrl)
    return (
      <Pressable testID="voucherCodeBtn" onPress={() => Linking.openURL(redeemUrl)} style={styles.container}>
        <Text variant="sm-bold">{redeemUrl}</Text>
        <MaterialIcons name="arrow-forward" size={scale(24)} color={colors.secondary.orchid} />
      </Pressable>
    );
  return null;
}

VoucherCode.defaultProps = {
  redeemUrl: '',
};

export default VoucherCode;
